import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import FloatingWhatsApp from "./components/FloatingWhatsApp/FloatingWhatsApp";
import "./i18n"; // init: lataa locales/* ja asettaa i18nextin

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <>
    <App />
    <FloatingWhatsApp />
  </>
    </BrowserRouter>
  </React.StrictMode>
);



